<template>
  <div class="container">
    <q-banner v-if="success" class="app-banner app-banner--success" dense rounded>
      Données enregistrées
    </q-banner>
    <div class="column">
      <h4><q-icon name="layers" /> Créer une galerie d'exposition</h4>
      <q-btn @click="navigateToTemplateManagement" color="secondary" label="Galeries" />

    </div>
    <div class="column">
      <h4><q-icon name="help_outline" /> Instructions</h4>
      <p>Vous allez désormais construire votre exposition, nous vous proposons deux options : </p>
      <ul>
        <li>Vous pouvez insérer vos documents dans des galeries d'expositions. La présentation sera la même pour tous les
          documents</li>
        <li>Ou construire vous même votre exposition personnalisée en réalisant un parcours pour l'usager à l'aide de
          points intéractifs</li>
      </ul>
    </div>
    <div class="column">
      <h4><q-icon name="create_new_folder" /> Créer une exposition personnalisée</h4>
      <q-btn @click="createCustomExpo" color="primary">Créer une exposition</q-btn>
    </div>
  </div>
</template>
  
<script>
import { ref, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import axios from 'axios';
import { useStore } from 'vuex';
export default {
  name: 'ExpositionTemplateSetup',
  setup() {
    const store = useStore();
    const selectedTemplate = ref(null);
    const router = useRouter();
    const templates = ref([]);
    let hasTemplate = ref(false);
    let success = ref(false);
    const exhibitId = computed(() => store.state.exhibitId);

    const createCustomExpo = async () => {
      selectedTemplate.value = {
        "exhibit_id": exhibitId.value,
        "id": 6,
        "name": "template_6",
        "template_id": 6,
        "thumbnail": null
      }
      await changeTemplate();
      // Réinitialiser les données pour garantir un état propre
      store.commit('RESET_EXHIBIT_DATA');
      store.commit('SET_EXHIBITID', exhibitId.value);
      router.push({ name: 'Point' });
    }

    //Récupération des templates
    const getTemplates = async () => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/templates`;
        let response = await axios.get(url);
        templates.value = response.data;
      } catch (error) {
        console.log(error);
      }
    };

    //Récupération du template courant si il existe
    const getCurrentTemplate = async () => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/template/${exhibitId.value}`;
        let response = await axios.get(url);
        if (response.data.length > 0) {
          hasTemplate.value = true;
          selectedTemplate.value = response.data[0];
        }
      } catch (error) {
        console.log(error);
      }
    };

    const navigateToTemplateManagement = () => {
      router.push({ name: 'TemplateManagement' });
    }

    //Changement de template
    const changeTemplate = async () => {
      try {
        console.log("Changement de template")
        let url = `${process.env.VUE_APP_BASEURL}/template`;
        let body = {
          exhibitId: store.state.exhibitId,
          templateId: selectedTemplate.value.id,
        };
        await axios.post(url, body);
        success.value = true;
        setTimeout(() => {
          success.value = false;
        }, 4000);
      } catch (error) {
        console.log(error);
      }
    };

    onMounted(() => {
      getTemplates();
      setTimeout(() => {
        getCurrentTemplate();
      }, 1000);
    });

    return {
      selectedTemplate,
      templates,
      exhibitId,
      hasTemplate,
      success,
      createCustomExpo,
      getCurrentTemplate,
      changeTemplate,
      navigateToTemplateManagement,
    };
  },
};
</script>
  
<style scoped>
.container {
  display: flex;
  justify-content: space-between;
}

.column {
  flex: 1;
  margin: 10px;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 10px;
}

.banner {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99999;

  /* Design */
  padding: 15px 30px;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  /* Typographie */
  font-size: 16px;
  font-family: 'Helvetica', sans-serif;
  /* Remplacez par la police de votre choix */

  /* Transition */
  transition: all 0.3s ease-in-out;
}
h4 {
    font-size: 20px;
    font-weight: 600;
}
</style>
  